import { withTranslation, TFunction } from "react-i18next";
import {
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import i18n from "i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import {
  ContactActions,
  ContactBlock,
  ContactLine,
  ContactText,
  PrimaryContact,
  FooterBottom,
  FooterBrand,
  FooterColumn,
  FooterColumns,
  FooterGrid,
  FooterSection,
  FooterTitle,
  FooterLink,
  LanguageSwitch,
  LanguageSwitchContainer,
  MapFrame,
  MutedText,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  const isArabic = i18n.language?.startsWith("ar");
  const handleChange = (language: string) => {
    localStorage.setItem("ashursoft-language", language);
    i18n.changeLanguage(language);
  };

  return (
    <FooterSection>
      <Container>
        <FooterGrid>
          <FooterBrand>
            <SvgIcon
              src="logo.svg"
              aria-label="Ashur Soft"
              width="150px"
              height="150px"
            />
            <p>
              {t(
                "Enterprise AI and automation solutions for businesses from Mosul, Iraq.",
              )}
            </p>
          </FooterBrand>

          <FooterColumns>
            <FooterColumn>
              <FooterTitle>{t("Contact")}</FooterTitle>
              <ContactBlock>
                <PrimaryContact
                  href="https://wa.me/9647759955841"
                  target="_blank"
                  rel="noopener noreferrer">
                  <WhatsAppOutlined />
                  <span>{t("Let's Chat")}</span>
                </PrimaryContact>
                <ContactLine href="mailto:mahmoudalsaffar322@gmail.com">
                  <MailOutlined />
                  <ContactText>mahmoudalsaffar322@gmail.com</ContactText>
                </ContactLine>
                <ContactLine href="tel:+9647759955841">
                  <PhoneOutlined />
                  <ContactText>+964 775 995 5841</ContactText>
                </ContactLine>
                <ContactActions>
                  <a href="mailto:mahmoudalsaffar322@gmail.com">{t("Email")}</a>
                  <a
                    href="https://wa.me/9647759955841"
                    target="_blank"
                    rel="noopener noreferrer">
                    WhatsApp
                  </a>
                </ContactActions>
              </ContactBlock>
            </FooterColumn>

            <FooterColumn>
              <FooterTitle>{t("Company")}</FooterTitle>
              <FooterLink to="/about">{t("About")}</FooterLink>
              <FooterLink to="/services">{t("Services")}</FooterLink>
              <FooterLink to="/services/ai-solutions">{t("AI Solutions")}</FooterLink>
              <FooterLink to="/services/software-development">
                {t("Software Development")}
              </FooterLink>
              <FooterLink to="/services/computer-vision">
                {t("Computer Vision")}
              </FooterLink>
              <FooterLink to="/services/industrial-automation">
                {t("Industrial Automation")}
              </FooterLink>
              <FooterLink to="/technology">{t("Technology")}</FooterLink>
              <FooterLink to="/products">{t("Products")}</FooterLink>
              <FooterLink to="/case-studies">{t("Case Studies")}</FooterLink>
              <FooterLink to="/contact">{t("Contact")}</FooterLink>
            </FooterColumn>

            <FooterColumn>
              <FooterTitle>{t("Address")}</FooterTitle>
              <MutedText dir={isArabic ? "rtl" : "ltr"}>
                <EnvironmentOutlined />
                {t("Sargon Business Complex, opposite Mosul Park, Mosul, Iraq")}
              </MutedText>
              <LanguageSwitchContainer aria-label={t("Language")}>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  English
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("ar")}>
                  العربية
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </FooterColumn>
          </FooterColumns>
        </FooterGrid>

        <MapFrame
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56701.8430443729!2d43.05784329361287!3d36.32927159540492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x400795001d03a9fd%3A0x236991eb294253cf!2z2KfYtNmI2LEg2LPZiNmB2Kog2YTZhNit2YTZiNmEINin2YTYqtmC2YbZitipINmI2KfZhNio2LHZhdis2YrYqQ!5e1!3m2!1sen!2siq!4v1744298848727!5m2!1sen!2siq"
          title="Ashur Soft Location"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />

        <FooterBottom>
          <span>© {new Date().getFullYear()} Ashur Soft</span>
          <span>{t("Enterprise AI for business operations")}</span>
        </FooterBottom>
      </Container>
    </FooterSection>
  );
};

export default withTranslation()(Footer);
